import { DialogComponent } from './dialog';
export * from './dialog';
DialogComponent.define();
